import React, { Fragment, useEffect, Suspense} from 'react';
import {Link} from 'react-router-dom';
import {ArrowUpRight} from 'react-feather';


// Components
const AllProjects = React.lazy(()=>import('../Sections/ProjectsPage/allProjects.js')); 


const Projects = (props) => {

  // Adding custom class to body 
  useEffect(() =>{
    props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");

    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
   })

  return (
    <Fragment>
    <Suspense fallback={<div>Loading...</div>}><AllProjects /></Suspense>
  
       {/* Footer CTA Ribbon */}
       <section id='take-next-leap' key='about'>
            <div className='take-next-leap'>
                <div className='take-next-leap__left'>
                    <h1 className="heading4 black">Get everything you need <span>to grow your business!</span></h1>
                </div>
                <div className='take-next-leap__right'>
                    <p><Link to='/contact-us'>Talk to us today<ArrowUpRight/></Link></p>
                </div>
            </div>
        </section>
        {/* Footer CTA Ribbon */}
    </Fragment>
  )
}
export default Projects;
